import React from 'react';

import { colorsPalette } from '../../theme';
import useStyles from './styles';

const ExpertsSmallIcon = ({ color = colorsPalette.white, ...props }) => {
  const classes = useStyles()();

  return (
    <svg
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      {...props}
      color={color}
    >
      <path
        className={classes.element}
        d="M20,20a4.00009,4.00009,0,0,0-4-4H8a4.00009,4.00009,0,0,0-4,4v2H20Z"
      />
      <polygon
        className={classes.element}
        points="12 2 13.852 4.95 17.231 5.8 14.997 8.474 15.233 11.95 12 10.651 8.767 11.95 9.003 8.474 6.769 5.8 10.148 4.95 12 2"
      />
    </svg>
  );
};

export default ExpertsSmallIcon;
